let _this;
export default {
  name: "schedule-setting-modal",
  data(){
    return{
      addScheduleModal:false,
      weekDays: {'Sun':'0','Mon':'1', 'Tue' :'2', 'Wed':'3', 'Thur' :'4', 'Fri':'5', 'Sat':'6', 'PH':'10'},
      weekList:{'0': 'Sun','1': 'Mon', '2': 'Tue', '3': 'Wed', '4': 'Thur', '5': 'Fri', '6': 'Sat', '10': 'PH'},
      hourList:Array.from(new Array(24).keys()), /*24小时*/
      timeCodes:{
        '5':{cell:5,hourWid:'96px', codeWid:'8px',array:Array.from(new Array(288).keys())},
        '30':{cell:30,hourWid:'60px',codeWid:'30px', array:Array.from(new Array(48).keys())},
        '1440':{cell:1,hourWid:'48.75px',codeWid:'1170px', array:Array.from(new Array(1).keys())}},/*时间节点*/
      curMoment:{},/*当前时间段*/
      scheduleInfo:{
        name:'',
        timeList:[[],[],[],[],[],[],[],[],[],[],[]],
      },
      showTimeArray:[],
      scheduleText:'',/*提示显示时间*/
      ruleFlag:false,/*时间验证*/
      scheduleUnit: this.ApiService.scheduleSettingInfo.scheduleUnit,/*schedule设置的最小单位*/
      scheduleList:[],
      disableMinutes:[],/*不可选分钟*/
      disableMinutes1:[],/*结束时间可选23：59*/
      editFlag:false,/*编辑状态*/
    }
  },
  mounted(){
    _this = this;
  },
  watch:{
    'addScheduleModal':{
      handler(nv){
        if(nv){
          _this.initData();
        }
      }
    }
  },
  methods:{
    // 初始化数据
    initData:function () {
      this.ruleFlag = false;
      if(!_this.editFlag){
        _this.scheduleInfo = {
          name:'',
          timeList:[[],[],[],[],[],[],[],[],[],[],[]],
        };
        _this.scheduleList = [{
          startTime:'',
          endTime:'',
          weekDay:[]
        }]
      }
      _this.$validator.errors.clear('scheduleInfo');
      _this.multipleSelection();
      _this.getDisableTime();
    },
    // 获取不可选时间
    getDisableTime:function () {
      _this.disableMinutes = [];
      for(let i=0;i <= 59;i++){
        if(i % 5 > 0){
          _this.disableMinutes.push(i);
        }
      }
      _this.disableMinutes1 = JSON.parse(JSON.stringify(_this.disableMinutes));
    },
    // 时间框选
    multipleSelection: function () {
      /*可选项*/
      _this.$nextTick(() => {
        $(".day-period").selectable({
          filter: '.hour-segment',
          selected: function (e, ui) {
            _this.ruleFlag = false;
            $('.moment-tips').css({'display':'none'});
            let day = ui.selected.attributes["day"].value/1;
            let hour = ui.selected.attributes["moment"].value/1;
            let index = _this.scheduleInfo.timeList[day].indexOf(hour);
            if(index > -1){
              _this.scheduleInfo.timeList[day].splice(index,1);
            }else{
              _this.scheduleInfo.timeList[day].push(hour);
            }
            if(_this.scheduleUnit == 30){//编辑异常的Schedule过滤异常参数
              _this.scheduleInfo.timeList[day] = _this.scheduleInfo.timeList[day].filter(no=>{return no%1 === 0});
            }
          },
          stop:function () {
            _this.showTimeArray = _this.shareApi.makeUpTime(_this.scheduleInfo.timeList,_this.scheduleUnit);
          },
        });
      });
    },
    // 显示时间点
    viewTime:function (e,day) {
      if(e.target.className.indexOf('active') > -1){
        _this.showTimeArray.forEach(item=>{
          if(day === item.substring(0,item.indexOf(':')).replace(/\s*/g, '')){
            _this.scheduleText = item
          }
        })
        setTimeout(() => {
          $('.moment-tips').css({'display':'block','left':e.clientX,'top':e.clientY});
        },300)
      }
    },
    // 隐藏时间面板
    hideTime:function (e) {
      if(e.target.className.indexOf('active') > -1){
        $('.moment-tips').css({'display':'none'});
      }
    },
    // 信息保存
    saveSchedule:function () {
      this.verifyFormData();
      this.$validator.validateAll('scheduleInfo').then(result =>{
        if(result && !_this.ruleFlag){
          let subData = _this.transformSubData();
          if(_this.editFlag){
            _this.$ajax.post('Schedule/Edit/'+_this.scheduleInfo.id,subData).then(function (res) {
              msgNotice(res);
            })
          }else{
            _this.$ajax.post('Schedule/Add',subData).then(function (res) {
              msgNotice(res);
            })
          }
          function msgNotice(res) {
            if(res.data.success){
              _this.messageNotice('success',1);
              _this.$emit('saveSuccess');
              _this.addScheduleModal = false;
            }else{
              _this.messageNotice('error',res.data.message);
            }
          }
        }
      })
    },
    // 表单验证
    verifyFormData:function () {
      if(_this.scheduleUnit === 5){
        _this.scheduleList.forEach(item =>{
          if(item.startTime === '' || item.endTime === '' || item.weekDay.length === 0){
            _this.ruleFlag = true;
          }else {
            _this.ruleFlag = false;
          }
        })
      }else if(_this.showTimeArray.length === 0){
        _this.ruleFlag = true;
      }else {
        _this.ruleFlag = false;
      }
    },
    // 数据转化
    transformSubData:function () {
      let subData = {name:_this.scheduleInfo.name,details:[]};
      let weekObj = {'Sun':0,'Mon':1, 'Tue' :2, 'Wed':3, 'Thur' :4, 'Fri':5, 'Sat':6, 'PH':10};
     if(_this.scheduleUnit === 5){
        _this.scheduleList.forEach(item =>{
           let startMin = ((item.startTime.substring(0,item.startTime.indexOf(':')))*3600) + ((item.startTime.substring(item.startTime.indexOf(':')+1)) * 60),
               endMin = ((item.endTime.substring(0,item.endTime.indexOf(':')))*3600) + ((item.endTime.substring(item.endTime.indexOf(':')+1)) * 60);
           /*时间转化为分钟*/
          item.weekDay.forEach(day =>{
            let week = +day
            subData.details.push({
              week: week,
              startTime: startMin,
              endTime: (endMin === 86340) ? 86399 : endMin,
            })
          })
        })
      }else{
        _this.showTimeArray.forEach(item =>{
          let dayStr =  (item.substring(0,item.indexOf(':'))).trim();
          let array = item.substring(item.indexOf(':') + 1).split(',');
          //console.log(weekObj[dayStr])
          if(dayStr!==undefined) {
            array.forEach(time => {
              let startTime = time.split('-')[0].trim()
              let endTime = time.split('-')[1].trim()
              let startMin = ((startTime.substring(0, startTime.indexOf(':'))) * 3600) + ((startTime.substring(startTime.indexOf(':') + 1)) * 60)
              let endMin = ((endTime.substring(0, endTime.indexOf(':'))) * 3600) + ((endTime.substring(endTime.indexOf(':') + 1)) * 60);
              subData.details.push({
                week: weekObj[dayStr],
                startTime: startMin,
                endTime: (endMin === 86400) ? 86399 : endMin ,
              })
            })
          }
        });
      }
      return subData;
    },
    /***************5min自定义选择**************/

    // 日期选择
    selectDay:function (day,index) {
      this.ruleFlag = false;
      let result = _this.scheduleList[index].weekDay.indexOf(day);
      if(result > -1){
        _this.scheduleList[index].weekDay.splice(result,1);
      }else{
        _this.scheduleList[index].weekDay.push(day);
      }
    },
    // 新增schedule
    addSchedule:function () {
      _this.scheduleList.push({
        startTime:'',
        endTime:'',
        weekDay:[]
      })
    },
    deleteSchedule:function (index) {
      _this.scheduleList.splice(index,1)
      _this.verifyFormData()
    },
    // 判断结束时间选择23点时可选择59分
    judgeEndTime:function (time,index) {
      let num = _this.disableMinutes1.indexOf(59);
      if(time.split(':')[0] === '23' && num > -1){
         _this.disableMinutes1.splice(num,1);
      }else if(time.split(':')[0] !== '23' && num === -1){
        _this.scheduleList[index].endTime = time.split(':')[0] + ':00';
        _this.disableMinutes1.push(59);
      }
    },
    // 时间对比
    getTime:function (flag,index,type) {
      this.ruleFlag = false;
      if(!flag){
        // 选择开始时间
        if(!compareTime()) {
          _this.scheduleList[index].endTime = '';
        }
      }else if(type === 1){
        // 两个结束时间切换时，需判断是否选择了59分
        _this.judgeEndTime(_this.scheduleList[index].endTime,index);
      }
       function compareTime() {
        if(_this.scheduleList[index].startTime && _this.scheduleList[index].endTime){
          let startTime = new Date('2021-01-01 ' + _this.scheduleList[index].startTime).getTime();
          let endTime = new Date('2021-01-01 ' + _this.scheduleList[index].endTime).getTime();
          return (endTime - startTime > 0);
        }else{
          return true;
        }
      }
    },
    // 编辑schedule
    getScheduleInfo:function (data) {
      _this.multipleSelection()
      _this.scheduleInfo.name = data.name;
      _this.scheduleInfo.id = data.id;
      if(_this.scheduleUnit === 5){
        let timeArray = [];
        _this.showTimeArray = data.showTimeArray;
        _this.showTimeArray.forEach((day) =>{
          let list = day.split(','), week = day.substring(0,day.indexOf(':')-1) ;
          list.forEach((item,index) =>{
            if(index === 0){
              timeArray.push({
                day: _this.weekDays[week] ,
                time:item.slice(-17)
              });
            }else{
              timeArray.push({
                day:_this.weekDays[week],
                time:item
              });
            }
          })
        });
        // 将重复的日期对应的周几组合
        let repeatInfo = {};
        timeArray.forEach((date1) =>{
          repeatInfo[date1.time] = [];

        });
        timeArray.forEach((date2) =>{
          repeatInfo[date2.time].push(date2.day);
        });
        _this.scheduleList = [];
        for(let key in repeatInfo){
          _this.scheduleList.push({
            startTime:key.split('-')[0],
            endTime:(key.split('-')[1] == ' 24 : 00') ? '23:59' : key.split('-')[1],
            weekDay:repeatInfo[key]
          })
        }
        _this.addScheduleModal = true;
      }else {
        _this.scheduleInfo.timeList =  _this.transformTime(data)
        _this.showTimeArray = data.showTimeArray
        setTimeout(()=>{
          _this.addScheduleModal =true
        }, 1000);
      }
    },
    transformTime:function (data) {
      let timeArray  = data
      let array = [[],[],[],[],[],[],[],[],[],[],[]]
      timeArray.schedules.forEach(item => {
          for (let i in array) {
          if (i == item.week) {
            let start = '', end = ''
            item.times.forEach(day => {
              if (_this.scheduleUnit === 30) {
                start = day.startTime / 1800
                end = (day.endTime === 86399 ? 86400 : day.endTime) / 1800
              }
              if (_this.scheduleUnit === 86400) {
                start = day.startTime / 86400
                end =  (day.endTime === 86399 ? 86400 : day.endTime) / 86400
              }
              let arr=[],length=end-start,j=start+1;
              for(;arr.push(j++)<length;){
              }
              array[i] = array[i].concat(arr)
            })
          }
         }
        })
      return array
    }

  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/scheduleSettingModal.js